import type { PillarResult } from "@moneymap/domain";

const center = 140;
const radius = 102;

function point(index: number, value: number, count: number): [number, number] {
  const angle = -Math.PI / 2 + index * ((Math.PI * 2) / count);
  const distance = radius * Math.max(0.08, value / 100);
  return [center + Math.cos(angle) * distance, center + Math.sin(angle) * distance];
}

function polygonAt(value: number, count: number): string {
  return Array.from({ length: count }, (_, index) => point(index, value, count).join(",")).join(" ");
}

export function MoneyMap({ pillars }: { pillars: PillarResult[] }) {
  const dataPoints = pillars.map((pillar, index) => point(index, pillar.score ?? 14, pillars.length).join(",")).join(" ");
  return (
    <div className="money-map-wrap">
      <svg className="money-map" viewBox="0 0 280 280" role="img" aria-labelledby="map-title map-description">
        <title id="map-title">Seven-pillar financial protection map</title>
        <desc id="map-description">Unknown pillars remain close to the centre and are labelled below instead of being treated as low scores.</desc>
        {[25, 50, 75, 100].map((value) => <polygon key={value} points={polygonAt(value, pillars.length)} className="map-grid" />)}
        {pillars.map((_pillar, index) => {
          const [x, y] = point(index, 100, pillars.length);
          return <line key={index} x1={center} y1={center} x2={x} y2={y} className="map-axis" />;
        })}
        <polygon points={dataPoints} className="map-data" />
        {pillars.map((pillar, index) => {
          const [x, y] = point(index, pillar.score ?? 14, pillars.length);
          return <circle key={pillar.id} cx={x} cy={y} r="5" className={`map-dot status-${pillar.status}`} />;
        })}
      </svg>
      <ul className="map-legend" aria-label="Money Map pillar results">
        {pillars.map((pillar) => <li key={pillar.id}><span className={`status-pip status-${pillar.status}`} /><span>{pillar.label}</span><strong>{pillar.score === null ? "Not scored" : `${pillar.score}/100`}</strong></li>)}
      </ul>
    </div>
  );
}
